import React from 'react';
import Particles from 'react-tsparticles';
import { loadLinksPreset } from 'tsparticles-preset-links';
import { Engine } from 'tsparticles-engine';

const Truth = () => {
    interface ParticlesInit {
      (engine: Engine): Promise<void>;
    }

    const particlesInit: ParticlesInit = async (engine) => {
      await loadLinksPreset(engine);
    };

    return (
        <div>
            <Particles
                id="tsparticles"
                init={particlesInit}
                options={{
                    preset: "links",
                }}
            />
        </div>
    );
};

export default Truth;